document.addEventListener('DOMContentLoaded', () => {
  const sliders = document.querySelectorAll('.spx-pdp-image-slider spx-slider');
  if (!sliders.length) return;

  sliders.forEach((slider) => {
    const initForSlider = () => {
      const swiperInstance = /** @type {any} */ (slider).swiperInstance;
      if (!swiperInstance) {
        requestAnimationFrame(initForSlider);
        return;
      }

      const updateVideoState = () => {
        const slides = swiperInstance.slides || slider.querySelectorAll('.swiper-slide');
        const activeIndex = swiperInstance.activeIndex ?? 0;

        slides.forEach((/** @type {HTMLElement} */ slide, /** @type {number} */ index) => {
          const video = /** @type {HTMLVideoElement | null} */ (
            slide.querySelector('.spx-pdp-image-slider-item__video')
          );
          if (!video) return;

          const isActive = index === activeIndex;

          if (isActive) {
            if (video.paused) {
              video.play().catch(() => {});
            }
          } else {
            if (!video.paused) {
              video.pause();
            }
          }
        });
      };

      // 初始化时同步一次当前激活项
      updateVideoState();

      // 监听 Swiper 的 slide 切换，实时更新视频播放状态
      swiperInstance.on('slideChangeTransitionEnd', updateVideoState);
    };

    initForSlider();
  });
});

